module.exports = __webpack_public_path__ + "img/banner.abdd8b26.svg";